import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'customDate',
  standalone: true,
})
export class CustomDatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  transform(value: string | Date, pattern: string = 'dd.MM.yyyy'): string {
    try {
      const datePipe: DatePipe = new DatePipe(this.locale);
      return datePipe.transform(
        moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD']).toDate(),
        pattern
      )!;
    } catch (e) {
      return '';
    }
  }
}
